export default __webpack_public_path__ + "static/media/Ealing-01.59054a42.jpg";